import { render, staticRenderFns } from "./list_claims.vue?vue&type=template&id=64210b5c&scoped=true"
import script from "./list_claims.vue?vue&type=script&lang=js"
export * from "./list_claims.vue?vue&type=script&lang=js"
import style0 from "./list_claims.vue?vue&type=style&index=0&id=64210b5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64210b5c",
  null
  
)

export default component.exports